import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ModalDialogComponent } from '../../distributed-ui-components/modal-dialog/modal-dialog.component';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { ActivatedRoute } from '@angular/router';
import { UserProfile } from 'src/app/core/models/user';
import { SelfAssessmentInterpretation } from 'src/app/core/models/self-assessmentT3/SelfAssessmentInterpretation';
import { MasterHelper } from 'src/app/core/utilities';
import { overallAssessmentDropdownList } from 'src/app/core/models/self-assessmentT3/overallDropdownList';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { debug } from 'console';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { SelfAssessmentCkDataSaveModel } from 'src/app/core/models/self-assessmentT2/update-self-assessmentT2-model';
import { SelfAssessmentCkDataSaveT3Dto } from 'src/app/core/models/self-assessmentT3/overall-aseesment';
import { ckEditorBroadcastMessage } from 'src/app/core/models/signalR/ckEditorBroadcastMessage';
import { SignalRService } from 'src/app/core/services/signalR/signal-r.service';
import { SelfAssessmentJudgement } from 'src/app/core/models/self-assessmentT3/SelefassessmentJudgement';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { CkEditorRevisionComponent } from '../../shared/ck-editor-revision/ck-editor-revision.component';
import { Subscription } from 'rxjs';
import { VersionHistoryT3DataDto } from 'src/app/core/models/self-assessmentT3/version-filter-viewT3-model';
import { breadCrumbsList } from 'src/app/core/models/breadCrumbs/breadCrumbs';
import { cloneDeep } from 'lodash';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-judgment-t3',
  templateUrl: './judgment-t3.component.html',
  styleUrls: ['./judgment-t3.component.scss'],
})
export class JudgmentT3Component {
  @Input() summaryDetailsId!: string;
  isToastShow = false;
  isLoader: boolean = true;
  Judgement: string = 'Judgement';
  JudgmentId: number = 0;
  active: number = 0;
  toastModel: ToastViewModel = new ToastViewModel();
  judgmentList: SelfAssessmentJudgement = new SelfAssessmentJudgement();
  previousJudgmentList: SelfAssessmentJudgement = new SelfAssessmentJudgement();
  judgmentAssessmentDropdownList: overallAssessmentDropdownList =
    new overallAssessmentDropdownList();
  user: UserProfile = new UserProfile();
  summaryId: number = 0;
  selfAssessmentDocument: SelfAssessmentDocumentModel[] = [];
  tabs: string[] = [];
  showTab: boolean = false;
  breadCampsList: breadCrumbsList[] = []
  constructor(
    private selfAssessmentT3Service: SelfAssessmentTemplate3Service,
    public dialog: MatDialog,
    private _sessionService: SessionService,
    private ref: ChangeDetectorRef,
    private _signalRService: SignalRService,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA)
    public versionHistoryData: VersionHistoryT3DataDto,
    private _globalService: GlobalService
  ) {
    this.breadCampsList = [{ "name": "Assessment", "className": 'active' }, { "name": "Review", "className": "" }, { "name": "Approval", "className": "" }, { "name": "Approved", "className": "" }]
  }

  ngOnInit(): void {
    if (this.versionHistoryData && this.versionHistoryData.isVersonHistory) {
      this.fetchJudgementVersionHistoryData(
        this.versionHistoryData.overAssessmentId
      );
      this.tab = this.versionHistoryData.tab;
    } else {
      if (!this.summaryDetailsId) {
        this.route.params.subscribe((params: any) => {
          this.summaryDetailsId = params['id'];
          this.summaryId = parseInt(this.summaryDetailsId);
        });
      }
      this.getallJudgment();
    }
    this.getUserDetails();
    this.getOverallAssessmentAllDropDowns();
  }
  fetchJudgementVersionHistoryData(id: number) {
    this.selfAssessmentT3Service
      .getJudgementVersionHistoryDetails(id)
      .subscribe((data: any) => {
        this.judgmentList = data;
        this.showTab = true;
        this.judgmentList.id = data.judgementId;
        if (this.judgmentList.id > 0) {
          this.getAssessmentDocuments();
        }
        if (
          this.judgmentAssessmentDropdownList.actionClosedList &&
          this.judgmentAssessmentDropdownList.actionClosedList.length > 0 &&
          this.judgmentList.id > 0 &&
          this.selfAssessmentDocument &&
          this.selfAssessmentDocument.length > 0 &&
          this.user.fullName != ''
        ) {
          this.isLoader = false;
        }
      });
  }
  getjudgement(id: number) {
    this.selfAssessmentT3Service.getT3Judgement(id).subscribe((data: any) => {
      this.judgmentList = data;
      this.showTab = true;
      if (this.judgmentList.id > 0) {
        this.getAssessmentDocuments();
      }
      if (
        this.judgmentAssessmentDropdownList.actionClosedList &&
        this.judgmentAssessmentDropdownList.actionClosedList.length > 0 &&
        this.judgmentList.id > 0 &&
        this.selfAssessmentDocument &&
        this.selfAssessmentDocument.length > 0 &&
        this.user.fullName != ''
      ) {
        this.isLoader = false;
      }
      this.breadCrumbsSet();
      this.previousJudgmentList = cloneDeep(this.judgmentList);
    });
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }

  getAssessmentDocuments() {
    this.selfAssessmentT3Service
      .getSelfAssessmentT3JudgementDocument(this.judgmentList.id)
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        if (
          this.judgmentAssessmentDropdownList.actionClosedList &&
          this.judgmentAssessmentDropdownList.actionClosedList.length > 0 &&
          this.judgmentList.id > 0 &&
          this.selfAssessmentDocument &&
          this.user.fullName != ''
        ) {
          this.isLoader = false;
        }
      });
  }
  getOverallAssessmentAllDropDowns() {
    this.selfAssessmentT3Service
      .getT3InterpretationAssessmentDropdowns()
      .subscribe((res: overallAssessmentDropdownList) => {
        this.judgmentAssessmentDropdownList = res;
        if (
          this.judgmentAssessmentDropdownList.actionClosedList &&
          this.judgmentAssessmentDropdownList.actionClosedList.length > 0 &&
          this.judgmentList.id > 0 &&
          this.selfAssessmentDocument &&
          this.user.fullName != ''
        ) {
          this.isLoader = false;
        }
      });
  }
  // onChildVariableChangeT3(event: { data: any; type: string }) {
  //   var data = event.data;
  //   var type = event.type;
  //   if (type.toLowerCase() === 'JudgementDetails'.toLocaleLowerCase()) {
  //     this.judgmentList.JudgementDetails = data;
  //     this.judgmentList.muteInterpretationDetailsUsers =
  //       this.updateUserList(
  //         this.judgmentList.muteInterpretationDetailsUsers,
  //         this.user.fullName
  //       );
  //     this.ref.detectChanges();
  //   } else if (
  //     type.toLowerCase() === 'JudgementComments'.toLocaleLowerCase()
  //   ) {
  //     this.judgmentList.JudgementImplementationComments = data;
  //     this.judgmentList.muteImplementationCommentsUsers =
  //       this.updateUserList(
  //         this.judgmentList.muteImplementationCommentsUsers,
  //         this.user.fullName
  //       );
  //     this.ref.detectChanges();
  //   } else if (type.toLowerCase() === 'ReviewerComments'.toLocaleLowerCase()) {
  //     this.judgmentList.reviewerComments = data;
  //     this.judgmentList.muteInterpretationDetailsUsers =
  //       this.updateUserList(
  //         this.judgmentList.muteInterpretationDetailsUsers,
  //         this.user.fullName
  //       );
  //     this.ref.detectChanges();
  //   } else if (type.toLowerCase() === 'ApproverComments'.toLocaleLowerCase()) {
  //     this.judgmentList.approverComments = data;
  //     this.judgmentList.muteInterpretationDetailsUsers =
  //       this.updateUserList(
  //         this.judgmentList.muteInterpretationDetailsUsers,
  //         this.user.fullName
  //       );
  //     this.ref.detectChanges();
  //   } else if (type.toLowerCase() === 'ActionDetails'.toLocaleLowerCase()) {
  //     this.judgmentList.actionDetails = data;
  //     this.judgmentList.muteInterpretationDetailsUsers =
  //       this.updateUserList(
  //         this.judgmentList.muteInterpretationDetailsUsers,
  //         this.user.fullName
  //       );
  //     this.ref.detectChanges();
  //   } else if (type.toLowerCase() === 'ActionClosure'.toLocaleLowerCase()) {
  //     this.judgmentList.actionClosure = data;
  //     this.judgmentList.muteInterpretationDetailsUsers =
  //       this.updateUserList(
  //         this.judgmentList.muteInterpretationDetailsUsers,
  //         this.user.fullName
  //       );
  //     this.ref.detectChanges();
  //   }
  // }
  // async onEditorSave(event: {
  //   data: SelfAssessmentCkDataSaveModel;
  //   id: number;
  // }) {

  //   let data = event.data;
  //   let payloadData: SelfAssessmentCkDataSaveT3Dto =
  //     new SelfAssessmentCkDataSaveT3Dto(
  //       data.ckData,
  //       data.ckName,
  //       data.selfAssessmentT2Id,
  //       event.id,
  //       data.userName
  //     );
  //   this.selfAssessmentT3Service
  //     .updateSelfAssessmentCKForJudgementT3(payloadData)
  //     .subscribe((res: any) => {
  //       this.broadCastMessageOnEditorSave();
  //     });
  // }
  // broadCastMessageOnEditorSave() {
  //   let boradcastMessage = new ckEditorBroadcastMessage();
  //   boradcastMessage.selfAssessmentId = parseInt(this.summaryDetailsId);
  //   boradcastMessage.userId = this.user.externalUserId;
  //   boradcastMessage.userName = this.user.fullName;
  //   this._signalRService
  //     .broadcastMessage(boradcastMessage)
  //     .subscribe((result: any) => {});
  // }
  // updateUserList(userlist: string, newUser: string): string {
  //   if (userlist) {
  //     const userList: string[] = userlist.split(',');
  //     const isPresent: boolean = userList.includes(newUser);
  //     if (!isPresent) {
  //       userList.push(newUser);
  //     }
  //     userlist = userList.join(',');
  //   } else {
  //     userlist = newUser;
  //   }
  //   return userlist;
  // }
  addAdditonalJudgment() {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to add a new Judgement?',
        title: 'Add New Judgement',
        btnText: 'Ok',
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.selfAssessmentT3Service
          .addAdditionalJudgeMent(parseInt(this.summaryDetailsId))
          .subscribe((result: any) => {
            let data = result;
            this.getallJudgment();
          });
      }
    });
  }
  DefaultOpen() {
    if (this.tabs.length != 0) {
      this.JudgmentId = parseInt(this.tabs[0]);
      this.setTab(this.JudgmentId, 0);
    }
  }
  tab: number = 0;
  activatedTabIndex: number = 1;
  setTab(id: number, index: number) {
    this._globalService.selectedSubmitterName = '';
    this._globalService.selectedReviewerName = [];
    this._globalService.selectedApproverName = [];
    this._globalService.selectedCondApproverName = [];
    this.active = index;
    this.showTab = false;
    this.isLoader = true;
    this.JudgmentId = id;
    this.tab = index + 1;
    this.getjudgement(this.JudgmentId);
    this.ref.detectChanges();
  }
  //Returning the list of Interpretations Id
  getallJudgment() {
    this.selfAssessmentT3Service
      .getAllJudgmentsById(parseInt(this.summaryDetailsId))
      .subscribe((data: any) => {
        this.tabs = data;
        this.DefaultOpen();
      });
  }
  getUserDetails() {
    this._sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      if (
        this.judgmentAssessmentDropdownList.actionClosedList &&
        this.judgmentAssessmentDropdownList.actionClosedList.length > 0 &&
        this.judgmentList.id > 0 &&
        this.selfAssessmentDocument &&
        this.selfAssessmentDocument.length > 0 &&
        this.user.fullName != ''
      ) {
        this.isLoader = false;
      }
    });
  }

  async savejudgement() {
    await this.selfAssessmentT3Service.triggerCkEditorChildFunctionAsync();
    this.selfAssessmentT3Service
      .saveJudgementT3(this.judgmentList)
      .subscribe((x) => {
        this.alertMessage('success', 'Judgement saved successfully');
        setTimeout(() => {}, 3500);
      });
  }
  @Output() notifyCkEditorChange: EventEmitter<any> = new EventEmitter<any>();
  notifyDetailsComponentCkEditorChange() {
    this.notifyCkEditorChange.emit();
  }

  async isReadyForReviewChanged(checked: boolean) {
    if(checked){
      this.changeBreadCrumbs("Review");
    }
    else{
      this.changeBreadCrumbs("Assessment");
    }
  }

  isReadyForApprovalChanged(checked:boolean) {
    if(checked){
      this.changeBreadCrumbs("Approval");
    }
    else{
      this.changeBreadCrumbs("Review");
    }
  }

  isReadyForConditionalApprovalChanged(checked:boolean) {
    if(checked){
      this.changeBreadCrumbs("Approved");
    }
    else{
      this.changeBreadCrumbs("Approval");
    }
  }

  changeBreadCrumbs(item: string) {
    if (this.breadCampsList) {
      // Use map to set className to "" for all items
      this.breadCampsList = this.breadCampsList.map(item => {
        return { ...item, className: "" };
      });
      const index = this.breadCampsList.findIndex(ob => ob.name === item);
      if (index !== -1) {
        //this.breadCampsList[reviewIndex].className = 'active'; // Set new class name for the 'Review' item
        this.breadCampsList = [
          ...this.breadCampsList.slice(0, index + 1).map(item => ({ ...item, className: 'active' })),
          ...this.breadCampsList.slice(index + 1)
        ];
      }
    }
  }

  breadCrumbsSet() {
    if (this.judgmentList.conditionalApproval == true) {
      this.changeBreadCrumbs("Approved");
    }
    else if (this.judgmentList.readyForApproval == true) {
      this.changeBreadCrumbs("Approval");
    }
    else if (this.judgmentList.readyForReview == true) {
      this.changeBreadCrumbs("Review");
    }
    else {
      this.changeBreadCrumbs("Assessment");
    }
  }

  isDataChange:boolean=false;
  performLeaveCheck(): boolean {
    const currentDataStr = JSON.stringify(this.judgmentList);
    const previousDataStr = JSON.stringify(this.previousJudgmentList);
    if (currentDataStr !== previousDataStr) {
      this.isDataChange=true;
      // Perform actions based on changes
    } else {
      this.isDataChange=false;
    }
    return this.isDataChange;
  }
  setPreviousData(){
    this.previousJudgmentList = cloneDeep(this.judgmentList); 
  }
}
